import { render } from "./devSetting.vue?vue&type=template&id=14e4c74c"
import script from "./devSetting.vue?vue&type=script&lang=js"
export * from "./devSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__